exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-modal[data-v-ed3a81b2]{z-index:0!important}", ""]);

// exports
